<template>
    <div style="height: 100%; overflow: hidden">
        <!-- 分页没做  --  总数没有显示  -  查询功能没做   -->
        <div style="margin-top: 60px" v-show="!iframeShow">
            <div style="width: 100%; text-align: center">
                <!-- <img :src="'static/img/logo.png'" /><br> -->
                <h2>中国雅江清洁能源有限公司</h2>
                <div style="margin-top: 15px; margin-left: 50px; margin-right: 10px">
                    <div style="display: flex">
                        <div style="width: 500px"></div>
                        <el-select class="select-item-mode1" style="width: 300px" placeholder="请选择" v-model="choosese">
                            <el-option label="作者" value="1"></el-option>
                            <el-option label="主题" value="2"></el-option>
                            <el-option label="时间" value="3"></el-option>
                            <el-option label="关键字" value="4"></el-option>
                            <el-option label="引文" value="5"></el-option>
                            <el-option label="来源" value="6"></el-option>
                            <el-option label="全文检索" value="7"></el-option>
                        </el-select>
                        <el-input class="select-input" placeholder="请输入内容" v-model="searchnew"></el-input>
                        <input @click="searchclick" type="submit" value="点击检索" id="su" class="btn self-btn bg s_btn" />
                        <div style="width: 900px"></div>
                    </div>
                </div>
            </div>
        </div>
        <div style="display: flex; flex-direction: row; width: 100%" v-show="!iframeShow">
            <div style="width: 50%; margin-top: 40px; margin-left: 20px">
                <div>
                    <el-header>关键词热度</el-header>
                    <el-main>
                        <div id="container4"></div>
                    </el-main>
                </div>
            </div>
            <div style="margin-left: 5%; width: 40%">
                <div v-if="pagecount > 0">总共查询结果{{ pagecount }}</div>
                <el-pagination layout="prev, pager, next" :total="pagecount" :page-size="pageSize"
                    @current-change="searchBook" :current-page.sync="page" background v-if="pagecount > 0">
                </el-pagination>
                <div class="box_left">
                    <div v-for="(item, index) in bookTableList" :key="index" class="left_item">
                        <div class="flex">
                            <a class="item_book" v-if="item.bookurl != 'null'" @click="preViewBook(item)">{{ item.book
                            }}</a>
                            <a class="item_bookurl" v-if="item.bookurl == 'null'">{{ item.book }}</a>
                            <a v-if="false" class="item_add">+收藏</a>
                        </div>
                        <div class="flex">
                            <a class="item_author">{{ item.zuozhe == "null" ? "" : item.zuozhe }}</a>
                        </div>
                        <div class="flex">
                            <span class="item_time">{{ item.year == "null" ? "" : "(" + item.year + ")" }}</span>
                        </div>
                        <div class="flex" v-if="false">
                            <a class="item_yinyong">引用 333 | 浏览 0</a>
                            <a class="item_down">下载全文</a>
                        </div>
                    </div>
                </div>
                <el-pagination layout="prev, pager, next" :total="pagecount" :page-size="pageSize"
                    @current-change="searchBook" :current-page.sync="page" background v-if="pagecount > 0">
                </el-pagination>
            </div>

        </div>
        <div v-if="iframeShow" class="iframeClass">
            <div style="border: 1px solid; background: white">
                <el-button type="info" icon="el-icon-close" size="small" @click="iframeShow = false">取消预览</el-button>

            </div>
            <div class="biaoji">
                <iframe :src="iframefileUrl" frameborder="0" width="100%" height="100%" ref="myIframe"
                    id="myIframe"></iframe>
            </div>
        </div>
        <div style="height: 100px"></div>
    </div>
</template>

<script>
import userapi from "@/api/user";
import G6 from "@antv/g6";
import Chart from "@antv/chart-node-g6";
import { PDFURL } from '../../utils/baseUrl.js'
export default {
    components: {
        Map,
        // Echart5,
    },
    data() {
        return {
            isPhone: false,
            bjre: [],
            searchnew: "",
            choosese: "7",
            pageSize: 10,
            bookTableList: [],
            page: 1,
            pagecount: 0,
            keyword: "",
            person: "",
            book: "",
            year: "",
            company: "",
            literature: "",
            gjz: "",
            keyitems: [],
            seword: "",
            iframeShow: false,
            fileUrl: "",
            iframefileUrl: '',//iframe 查看文件地址

            /*PDF相关变量 */
            tagShow: true, //显示或者隐藏标记按钮切换
            iframeWin: "", //iframe中的所有变量
            textlayer: "", //pdf渲染的外边界div
            pageNumber: [], //标记所在在PDF的页码,因为存在标记跨页的情况，所以是一个数组
            selectNodes: "", //选中标记的node
            startOffset: 0, //标记文本的起始节点偏移量
            selectDom: {},
            signArray: [], //用来存储数据的标记
            signIndex: 0,
            currentScaleValue: 1, //用来记录当店PDF的缩放大小，一般默认100%
            signInfo: [],
            nowpage: 1,
            nowbook: "a",
            colorToMark: "#409EFF",
            showList: null,
            user: {},
            detailList: []
        };
    },
    watch: {
        // (document.getElementById('myIframe').contentWindow.showList){
        //     deep:true,
        //     handler(newValue){
        //         console.log("newValue",newValue);
        //     }
        // }
    },
    mounted() {
        userapi.getUserByToken().then((res) => {
            this.user = res.data.data
        })



        if (window.innerWidth > 1100) {
            this.isPhone = false;
        } else {
            this.isPhone = true;
        }
        this.keyword = this.$route.query.keyword;
        this.person = this.$route.query.person;
        this.book = this.$route.query.book;
        this.year = this.$route.query.year;
        this.company = this.$route.query.company;
        this.literature = this.$route.query.literature;
        this.gjz = this.$route.query.gjz;
        //ask 万姐
        // if (
        //     this.keyword &&
        //     this.person &&
        //     this.book &&
        //     this.year &&
        //     this.company &&
        //     this.literature &&
        //     this.gjz != ""
        // ) {
        //     this.searchBook();
        // }
        this.getType();
    },
    methods: {
        clearthis(row) {
            this.bjre = this.bjre.filter((item) => {
                return item.c_id != row.c_id;
            });
            this.csh(this.bjre);
            userapi
                .getRequest("/api/deletere", {
                    c_id: row.c_id,
                })
                .then((res) => { });
        },
        clear() {
            let signDivs = this.iframeWin.$(".signDiv");
            for (let i = 0; i < signDivs.length; i++) {
                signDivs[i].remove();
            }
        },
        draw() {
            if (document.getElementById("myIframe").contentWindow.pdfCanvas) {
                let pdfCanvas =
                    document.getElementById("myIframe").contentWindow.pdfCanvas;
                pdfCanvas.setColor(this.hexToRgba(this.colorToMark));
                pdfCanvas.setBorderColor("blue");
                pdfCanvas.enableRectangle();
                this.showList =
                    document.getElementById("myIframe").contentWindow.showList;
            }
            console.log(
                "window",
                this.showList,
                document.getElementById("myIframe").contentWindow.showList
            );
        },
        hexToRgba(hex) {
            return (
                "rgba(" +
                parseInt("0x" + hex.slice(1, 3)) +
                "," +
                parseInt("0x" + hex.slice(3, 5)) +
                "," +
                parseInt("0x" + hex.slice(5, 7)) +
                "," +
                " 0.2" +
                ")"
            );
        },
        searchclick() {
            if (this.searchnew == "") {
                alert("请输入内容");
                return;
            }
            this.keyword = "";
            this.person = "";
            this.book = "";
            this.year = "";
            this.company = "";
            this.literature = "";
            this.gjz = "";
            if (this.choosese == "1") {
                this.person = this.searchnew;
            } else if (this.choosese == "2") {
                this.book = this.searchnew;
            } else if (this.choosese == "3") {
                this.year = this.searchnew;
            } else if (this.choosese == "4") {
                this.gjz = this.searchnew;
            } else if (this.choosese == "5") {
                this.company = this.searchnew;
            } else if (this.choosese == "6") {
                this.literature = this.searchnew;
            } else if (this.choosese == "7") {
                this.keyword = this.searchnew;
            }
            this.searchBook();
        },
        // 修改前没有传递参数,修改后的参数用参数传递
        selectByKey(data) {
            userapi
                .getRequest("/api/selectByKey", {
                    // searchnew: this.searchnew,
                    searchnew: data,
                })
                .then((res) => {
                    this.choosese = String(res.data);
                    this.keyword = "";
                    this.person = "";
                    this.book = "";
                    this.year = "";
                    this.company = "";
                    this.literature = "";
                    this.gjz = "";

                    if (this.choosese == "1") {
                        this.person = data;
                    } else if (this.choosese == "2") {
                        this.book = data;
                    } else if (this.choosese == "3") {
                        this.year = data;
                    } else if (this.choosese == "4") {
                        this.gjz = data;
                    } else if (this.choosese == "5") {
                        this.company = data;
                    } else if (this.choosese == "6") {
                        this.literature = data;
                    } else if (this.choosese == "7") {
                        this.keyword = data;
                    }
                    this.searchBook();
                });
        },

        preViewBook(row) {
            this.nowbook = row.book;
            console.log("row", row);
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            userapi
                .getRequest("/api/getRe", {
                    filename: row.book,
                })
                .then((res) => {
                    console.log("res", res.data);
                    this.bjre = res.data;
                    // this.csh(res.data);
                });

            userapi
                .getRequest("/search/dealBook", {
                    keyword: this.seword,
                    fileurl: row.bookurl,
                })
                .then((res) => {
                    loading.close();
                    let fileUrl = res.data.replace("/home/tscon/we/mcc/", "https://edam.tscon.cn:7778/");
                    this.iframefileUrl = PDFURL + '?url=' + fileUrl
                    // this.iframefileUrl = 'http://192.168.1.30:5173/' + '?url=' + fileUrl
                    // this.fileUrl =
                    // "https://mcc.wedam.com.cn/earthgo/static/pdfjs/web/viewer.html?file=" +
                    // res.data.replace(
                    //     "/home/tscon/we/mcc/",
                    //     "https://mcc.wedam.com.cn/"
                    // );
                    // console.log( this.fileUrl)
                    // this.fileUrl =
                    //   "http://localhost:8080/static/pdfjs/web/viewer.html?file=http://localhost:8080/static/a.pdf&keyword=%E9%9B%85%E9%B2%81%E8%97%8F%E5%B8%83%E6%B1%9F#/";
                    this.iframeShow = true;

                    let _this = this;
                    let iframe = document.getElementById("myIframe");
                    // console.log(iframe)

                    // iframe 加载完成后执行并将双击事件过滤掉，因为双击事件可能也触发滑选，所以为了不误操作，将其剔除
                    this.bjre.forEach(item => {
                        document.getElementById('myIframe').contentWindow.postMessage(item.c_info, "*")
                    })
                    window.addEventListener('message', (event) => {
                        if (event.origin == 'https://edam.tscon.cn:7778') {
                            if (event.data.type == 'add') {//新增
                                userapi
                                    .postUrl("/api/addRe", {
                                        c_who: this.user.c_id,
                                        c_type: event.data.id,
                                        c_info: event.data.data,
                                        recordinfo: '',
                                        color: '',
                                        filename: row.book,

                                    }).then((res) => {
                                        console.log("res", res);
                                    })
                            } else if (event.data.type == 'delete') {
                                id = ''
                                for (let i = 0; i < this.bjre.length; i++) {
                                    let item = this.bjre[i]
                                    if (item.c_type == event.data.id) {
                                        id = item.c_id
                                        break
                                    }
                                }
                                userapi
                                    .getRequest("/api/deletere", {
                                        c_id: id,
                                    })
                                    .then((res) => { });
                            } else if (event.data.type == 'modify') {
                                let id = ''
                                for (let i = 0; i < this.bjre.length; i++) {
                                    let item = this.bjre[i]
                                    if (item.c_type == event.data.id) {
                                        id = item.c_id
                                        break
                                    }

                                }
                                userapi
                                    .getRequest("/api/deletere", {
                                        c_id: id,
                                    })
                                    .then((res) => {
                                        userapi
                                            .postUrl("/api/addRe", {
                                                c_who: this.user.c_id,
                                                c_type: event.data.id,
                                                c_info: event.data.data,
                                                recordinfo: '',
                                                color: '',
                                                filename: 'test.pdf',

                                            }).then((res) => {
                                                console.log("res", res);
                                            })
                                    });
                            }
                        }
                    });
                })
                .catch((error) => {
                    loading.close();
                });
        },
        createG6Tree4() {
            // 实际开发中把 window.AntVUtil 换成从 @antv/util 引入的相关模块
            // replace window.AntVUtil.isObject with

            // const { mix } = window.AntVUtil;

            let showNodes = [];
            let showEdges = [];
            let curShowNodes = [];
            let curShowEdges = [];
            let nodes = [];
            let edges = [];
            let nodeMap = new Map();
            let edgesMap = new Map();
            let curShowNodesMap = new Map();
            let highlighting = false;
            let currentFocus;
            // const width = document.getElementById( "container4" ).scrollWidth;
            const width =
                document.getElementById("container4").scrollWidth == 0
                    ? 300
                    : document.getElementById("container4").scrollWidth;

            const height = 500;

            const LIMIT_OVERFLOW_WIDTH = width;
            const LIMIT_OVERFLOW_HEIGHT = height;

            const mapNodeSizeAndFontSize = (nodes, propertyName, visualRange) => {
                let minp = 9999999999;
                let maxp = -9999999999;
                nodes.forEach((node) => {
                    const propertyValue =
                        node[propertyName] > 5000 ? 5000 : node[propertyName];
                    minp = propertyValue < minp ? propertyValue : minp;
                    maxp = propertyValue > maxp ? propertyValue : maxp;
                });
                const rangepLength = maxp - minp;
                const rangevLength = visualRange[1] - visualRange[0];
                nodes.forEach((node) => {
                    const propertyValue =
                        node[propertyName] > 5000 ? 5000 : node[propertyName];
                    node.size =
                        ((propertyValue - minp) / rangepLength) * rangevLength +
                        visualRange[0];
                    if (node.labelCfg && node.labelCfg.style) {
                        const textLength = node.label.length;
                        let fontSize = (1.3 * node.size) / textLength;
                        if (fontSize < 11) fontSize = 11;
                        node.labelCfg.style.fontSize = fontSize;
                    }
                });
            };

            const Colors = {
                noun: "#588c73",
                adj: "#f2e394",
                v: "#d96459",
                adv: "#f2ae72",
            };

            let graph;
            const layoutCfg = {
                type: "force",
                nodeSize: (d) => {
                    return d.size / 2 + 5;
                },
                nodeStrength: 2500,
                collideStrength: 0.8,
                alphaDecay: 0.01,
                preventOverlap: true,
                onTick: () => {
                    const nodeItems = graph.getNodes();
                    const height = graph.get("height");
                    const width = graph.get("width");
                    const padding = 10;
                    nodeItems.forEach((item) => {
                        const model = item.getModel();
                        if (model.x > width - padding) model.x = width - padding;
                        else if (model.x < padding) model.x = padding;

                        if (model.y > height - padding) model.y = height - padding;
                        else if (model.y < padding) model.y = padding;
                    });
                },
            };

            graph = new G6.Graph({
                container: "container4",
                width,
                height,
                linkCenter: true,
                layout: layoutCfg,
                modes: {
                    default: ["drag-canvas"],
                },
                defaultNode: {
                    type: "bubble",
                    size: 30,
                    labelCfg: {
                        position: "center",
                        style: {
                            fill: "white",
                            fontStyle: "bold",
                        },
                    },
                },
                defaultEdge: {
                    color: "#888",
                    type: "animate-line",
                },
            });
            function translate(x, y) {
                let moveX = x;
                let moveY = y;

                /* 获得当前偏移量*/
                const group = graph.get("group");
                const bbox = group.getBBox();
                const leftTopPoint = graph.getCanvasByPoint(bbox.minX, bbox.minY);
                const rightBottomPoint = graph.getCanvasByPoint(bbox.maxX, bbox.maxY);
                /* 如果 x 轴在区域内，不允许左右超过100 */
                if (x < 0 && leftTopPoint.x - x > LIMIT_OVERFLOW_WIDTH) {
                    moveX = 0;
                }
                if (x > 0 && rightBottomPoint.x - x < width - LIMIT_OVERFLOW_WIDTH) {
                    moveX = 0;
                }

                if (y < 0 && leftTopPoint.y - y > LIMIT_OVERFLOW_HEIGHT) {
                    moveY = 0;
                }
                if (y > 0 && rightBottomPoint.y - y < height - LIMIT_OVERFLOW_HEIGHT) {
                    moveY = 0;
                }
                graph.translate(-moveX, -moveY);
            }

            function refreshDragedNodePosition(e) {
                const model = e.item.get("model");
                model.fx = e.x;
                model.fy = e.y;
            }
            graph.on("node:dragstart", (e) => {
                graph.layout();
                refreshDragedNodePosition(e);
            });
            graph.on("node:drag", (e) => {
                refreshDragedNodePosition(e);
            });
            graph.on("node:dragend", (e) => {
                e.item.get("model").fx = null;
                e.item.get("model").fy = null;
            });
            graph.on("node:click", (e) => {
                // this.searchnew = e.item._cfg.model.label.substring(
                //   0,
                //   e.item._cfg.model.label.indexOf("(")
                // );
                // console.log(e.item._cfg.model.label)
                // 修改前
                // this.searchnew = e.item._cfg.model.label;
                // this.selectByKey();
                // 修改后
                // this.searchnew = e.item._cfg.model.label;
                this.selectByKey(e.item._cfg.model.label);
            });
            const loadData = (data) => {
                const layoutController = graph.get("layoutController");
                layoutController.layoutCfg.nodeStrength = 30;
                layoutController.layoutCfg.collideStrength = 0.8;
                layoutController.layoutCfg.alphaDecay = 0.01;
                nodes = data.nodes;
                edges = data.edges;

                showNodes = [];
                showEdges = [];
                nodeMap = new Map();
                edgesMap = new Map();
                // find the roots
                nodes.forEach((node) => {
                    if (!node.neighbor) {
                        node.label = node.text;
                        node.color = Colors[node.type];
                        node.style = {
                            fill: Colors[node.type],
                            lineWidth: 0,
                        };
                        let labelColor = "#fff";
                        if (node.type === "adj") {
                            labelColor = Colors.noun;
                        }
                        node.labelCfg = {
                            style: {
                                fontSize: 15,
                                fill: labelColor,
                                fontWeight: 300,
                            },
                        };
                        node.x = Math.random() * 800;
                        node.y = Math.random() * 800;
                        showNodes.push(node);
                    }
                    nodeMap.set(node.id, node);
                });

                mapNodeSizeAndFontSize(showNodes, "count", [40, 120]);
                showNodes.forEach((snode) => {
                    if (snode.size < 80) {
                        snode.type = "circle";
                    }
                });

                edges.forEach((edge) => {
                    // map the id
                    edge.id = `${edge.source}-${edge.target}`;
                    edge.style = {
                        lineWidth: 0.5,
                        opacity: 1,
                        strokeOpacity: 1,
                    };
                    edgesMap.set(edge.id, edge);
                });
                graph.data({
                    nodes: showNodes,
                    edges: showEdges,
                });
                graph.render();
            };

            var dndata = { nodes: this.node, edges: [] };
            // fetch(
            //   "https://gw.alipayobjects.com/os/basement_prod/0a749386-8593-44a2-a132-81dfa1fc3158.json"
            // )
            //   .then((res) => res.json())
            //   .then((data) => {
            //     loadData(data);
            //   });
            loadData(dndata);
            // click root to expand
            graph.on("node:click", (e) => {
                this.dialogTableVisible = true;
                curShowNodes = [];
                curShowEdges = [];
                const item = e.item;
                const model = item.getModel();
                if (model.neighbor) {
                    return;
                }
                // if clicked a root, hide unrelated items and show the related items
                if (!model.neighbor) {
                    const layoutController = graph.get("layoutController");
                    const forceLayout = layoutController.layoutMethods[0];
                    forceLayout.forceSimulation.stop();
                    // light the level 0 nodes
                    showNodes.forEach((snode) => {
                        if (snode.x < 0.5 * width) {
                            snode.x = 300;
                        } else {
                            snode.x = width - 300;
                        }
                    });
                    model.x = width / 2;
                    model.y = height / 2;
                    // animatively hide the items which are going to disappear
                    if (curShowEdges.length) {
                        curShowEdges.forEach((csedge) => {
                            const item = graph.findById(csedge.id);
                            item && graph.setItemState(item, "disappearing", true);
                        });
                    }
                    curShowNodes.forEach((csnode) => {
                        const item = graph.findById(csnode.id);
                        item && graph.setItemState(item, "disappearing", true);
                    });
                    graph.positionsAnimate();

                    // reset curShowNodes nad curShowEdges
                    curShowNodes = [];
                    curShowEdges = [];

                    // click on the same node which is the current focus node, hide the small nodes, change the layout parameters to roots view
                    if (currentFocus && currentFocus.id === model.id) {
                        currentFocus = undefined;
                        layoutController.layoutCfg.nodeStrength = 100;
                        layoutController.layoutCfg.collideStrength = 0.8;
                        layoutController.layoutCfg.alphaDecay = 0.01;
                    } else {
                        // click other focus node, hide the current small nodes and show the related nodes
                        currentFocus = model;
                        // change data after the original items disappearing
                        const layoutController = graph.get("layoutController");
                        layoutController.layoutCfg.nodeStrength = () => {
                            return -80;
                        };
                        layoutController.layoutCfg.collideStrength = 0.2;
                        layoutController.layoutCfg.linkDistance = (d) => {
                            if (!d.source.neighbor && !d.target.neighbor) return 150;
                            return 80;
                        };
                        layoutController.layoutCfg.edgeStrength = () => {
                            return 2;
                        };

                        curShowNodesMap = new Map();
                        // find the nodes which are the descendants of clicked model
                        edges.forEach((edge) => {
                            let nodeId = "";
                            let node;
                            if (edge.source === model.id) {
                                nodeId = edge.target;
                            } else if (edge.target === model.id) {
                                nodeId = edge.source;
                            } else {
                                return;
                            }
                            nodes.forEach((tnode) => {
                                if (tnode.id === nodeId) {
                                    node = tnode;
                                }
                            });
                            if (!node) return;
                            const randomAngle = Math.random() * 2 * Math.PI;
                            node.x = model.x + (Math.cos(randomAngle) * model.size) / 2 + 10;
                            node.y = model.y + (Math.sin(randomAngle) * model.size) / 2 + 10;
                            // const dist = (model.x - node.x) * (model.x - node.x) + (model.y - node.y) * (model.y - node.y);

                            if (!node.style) node.style = {};
                            node.style.lineWidth = 0;
                            node.style.opacity = 1;
                            if (node.neighbor) {
                                node.type = "animate-circle";
                                node.label = node.text;
                                const color = model.style.fill;
                                node.color = color;
                                node.style.fill = "#fff";
                                node.style.lineWidth = 1;
                                node.size = 30;
                                node.labelCfg = {
                                    style: {
                                        fontSize: 13,
                                        lineHeight: 19,
                                        fill: "#697B8C",
                                    },
                                    position: "center",
                                };
                            }
                            curShowNodes.push(node);
                            curShowNodesMap.set(node.id, node);

                            // add the edge connect from model to node which exists in edges
                            const edgeId = `${model.id}-${node.id}`;
                            const medge = edgesMap.get(edgeId);
                            if (medge) {
                                medge.color = model.color;
                                curShowEdges.push(medge);
                            }
                        });

                        edges.forEach((edge) => {
                            if (edge.source === model.id || edge.target === model.id) {
                                curShowEdges.push(edge);
                            }
                        });
                    }
                    setTimeout(() => {
                        graph.changeData({
                            nodes: showNodes.concat(curShowNodes),
                            edges: showEdges.concat(curShowEdges),
                        });
                        const nodeItems = graph.getNodes();
                        const edgeItems = graph.getEdges();
                        edgeItems.forEach((item) => {
                            graph.clearItemStates(item);
                        });
                        nodeItems.forEach((item) => {
                            graph.clearItemStates(item);
                            graph.setItemState(item, "appearing", true);
                        });
                    }, 400);
                }
            });
            graph.on("canvas:click", () => {
                currentFocus = undefined;
                const forceLayout = graph.get("layoutController").layoutMethods[0];
                forceLayout.forceSimulation.stop();
                const nodeItems = graph.getNodes();
                const edgeItems = graph.getEdges();
                if (highlighting) {
                    highlighting = false;
                } else {
                    nodeItems.forEach((item) => {
                        const model = item.getModel();
                        if (model.neighbor) {
                            graph.setItemState(item, "disappearing", true);
                        }
                    });
                    edgeItems.forEach((item) => {
                        graph.setItemState(item, "disappearing", true);
                    });
                    curShowNodes = [];
                    curShowEdges = [];
                    setTimeout(() => {
                        const layoutController = graph.get("layoutController");
                        layoutController.layoutCfg.nodeStrength = 100;
                        layoutController.layoutCfg.collideStrength = 0.8;
                        layoutController.layoutCfg.alphaDecay = 0.01;

                        graph.changeData({
                            nodes: showNodes,
                            edges: showEdges,
                        });
                    }, 400);
                }
            });

            if (typeof window !== "undefined")
                window.onresize = () => {
                    if (!graph || graph.get("destroyed")) return;
                    // if (!container || !container.scrollWidth || !container.scrollHeight)
                    //     return;
                    // graph.changeSize(container.scrollWidth, container.scrollHeight);
                };
        },

        getType() {
            // const loading = this.$loading({
            //   lock: true,
            //   text: "Loading",
            //   spinner: "el-icon-loading",
            //   background: "rgba(0, 0, 0, 0.7)",
            // });
            userapi
                .getRequest("/api/getRackSerach", {
                    type: 1,
                    count: 20,
                })
                .then((res) => {
                    // {
                    //     id: "8",
                    //     label: "8",
                    //     value: 21,
                    //     cluster: "d",
                    //     subCluster: "sb",
                    //     description: "this is node 8, \nand the value of it is 21"
                    // }

                    var node = [];
                    var source = [];
                    var data = res.data;
                    for (var key2 in res.data) {
                        // noun: "#588c73",
                        // adj: "#f2e394",
                        // v: "#d96459",
                        // adv: "#f2ae72",
                        var ty = "adv";
                        if (res.data[key2].hot < 5) {
                            ty = "adv";
                        } else if (res.data[key2].hot < 10) {
                            ty = "noun";
                        } else if (res.data[key2].hot < 15) {
                            ty = "v";
                        } else if (res.data[key2].hot < 20) {
                            ty = "adj";
                        }
                        node.push({
                            text: res.data[key2].c_info + "",
                            count: res.data[key2].hot * 1,
                            id: key2 + "bbbb",
                            type: ty,
                            lang: "en",
                        });
                    }
                    console.log(node);
                    this.node = node;

                    // var keyitems = []
                    // for(var a = 0 ; a <  res.data.data.length; a++){

                    //   keyitems.push(  {
                    //       id: a+"",
                    //       label: res.data.data[a],
                    //       value: res.data.data[a].split("--")[1],
                    //       cluster: "d",
                    //       subCluster: "sb",
                    //       description: "this is node 8, \nand the value of it is 21"
                    //   })searchBook1
                    // }
                    // this.keyitems = keyitems
                    this.createG6Tree4();
                });
        },
        searchBook() {
            this.pagecount = 0;
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            userapi
                .getRequest("/api/searchBook1", {
                    keyword: this.keyword,
                    person: this.person,
                    book: this.book,
                    year: this.year,
                    company: this.company,
                    literature: this.literature,
                    page: this.page,
                    pageSize: this.pageSize,
                    gjz: this.gjz,
                    keywordType: this.choosese,
                })
                .then((res) => {
                    loading.close();
                    var bookTableList = [];
                    if (res.data.data.count > 0) {
                        this.seword = res.data.data.seword;
                        this.pagecount = res.data.data.count;
                        for (var a = 0; a < res.data.data.list.length; a++) {
                            bookTableList.push({
                                bookurl: res.data.data.list[a].path,
                                book: res.data.data.list[a].name.substring(
                                    res.data.data.list[a].name.lastIndexOf("/") + 1
                                ),
                                zuozhe: res.data.data.list[a].authors,
                                year: res.data.data.list[a].year,
                            });
                        }
                    }
                    this.bookTableList = bookTableList;
                })
                .catch((error) => {
                    loading.close();
                });
        },
    },
};
</script>

<style scoped >
@import url('./de.css');

.el-header,
.el-footer {
    background-color: #b3c0d1;
    color: #333;
    text-align: center;
    line-height: 60px;
}

.el-main {
    background-color: #e9eef3;
    color: #333;
    text-align: center;
}

.select-input input {
    border-radius: 0 !important;
}

#su {
    cursor: pointer;
    width: 168px;
    height: 40px;
    line-height: 45px;
    line-height: 44px;
    padding: 0;
    background: 0 0;
    background-color: #4e6ef2;
    border-radius: 0 10px 10px 0;
    font-size: 17px;
    color: #fff;
    box-shadow: none;
    font-weight: 400;
    border: none;
    outline: 0;
}

.iframeClass {
    width: 100%;
    height: 96%;
}
</style>



// WEBPACK FOOTER //
// src/components/de.vue